import React, { useState } from 'react';
import StaffCostsRow from './StaffCostsRow';
import { Col, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import TotalTableRow from './TotalTableRow';
import '../elsterEmployeeTable.css';
const STAFF_COST_TABLE_HEADINGS_WITH_ELSTER_YEAR = ['employee_name_number', 'half_year_required', 'sum_working_hr_rd', 'rel_agreed_annual_working_hrs', 'project_join_employee', 'project_exit_employee', 'share_of_working_time', 'a1_exec_special_payment', 'a2_a2_sum_special_payments', 'a_sum_of_a1_and_a2', 'employers_social_security', 'a_gross_wage', 'b_employers_social_secutiry_contributions', ''];
const STAFF_COST_TABLE_HEADINGS_WITHOUT_ELSTER_YEAR = ['employee_name_number', 'sum_working_hr_rd', 'rel_agreed_annual_working_hrs', 'project_join_employee', 'project_exit_employee', 'share_of_working_time', 'a1_exec_special_payment', 'a2_a2_sum_special_payments', 'a_sum_of_a1_and_a2', 'employers_social_security', 'a_gross_wage', 'b_employers_social_secutiry_contributions', ''];
const StaffCosts = _ref => {
  let {
    data,
    setData,
    selectedProject,
    selectedProjectId,
    emptyStaffCosts,
    removeEmptyRow,
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const showHalfYearColumn = (elster === null || elster === void 0 ? void 0 : elster.elster_year_for_staff_cost) != null;
  const tableHeadings = showHalfYearColumn ? STAFF_COST_TABLE_HEADINGS_WITH_ELSTER_YEAR : STAFF_COST_TABLE_HEADINGS_WITHOUT_ELSTER_YEAR;
  const elsterYearForStaffCost = elster === null || elster === void 0 ? void 0 : elster.elster_year_for_staff_cost;
  const groupHeaderRow = /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), showHalfYearColumn && /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
    colSpan: 2,
    className: "text-center"
  }, t('employees_with_timesheets')), /*#__PURE__*/React.createElement("th", {
    colSpan: 2,
    className: "text-center"
  }, t('employees_with_100p_certificate')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
    colSpan: 3,
    className: "text-center"
  }, t('gross_wages_emp_wage_subj_tax_w_38_inc_tax_act')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
    colSpan: 2,
    className: "text-center"
  }, t('eligible_costs')), /*#__PURE__*/React.createElement("th", null));
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i,
      style: {
        width: '80px'
      }
    }, heading ? t(heading) : '');
  });
  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(StaffCostsRow, {
      data: data,
      setData: setData,
      rowData: currentData,
      key: currentData.id,
      selectedProjectId: selectedProjectId,
      selectedProject: selectedProject,
      showHalfYearColumn: showHalfYearColumn,
      elsterYearForStaffCost: elsterYearForStaffCost
    });
  });
  const emptyRows = emptyStaffCosts.map(emptyStaffCost => {
    return /*#__PURE__*/React.createElement(StaffCostsRow, {
      key: 'createRowStaffCostList' + emptyStaffCost.emptyRowId,
      emptyRowId: emptyStaffCost.emptyRowId,
      data: data,
      setData: setData,
      selectedProject: selectedProject,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyStaffCost,
      showHalfYearColumn: showHalfYearColumn,
      elsterYearForStaffCost: elsterYearForStaffCost
    });
  });
  const totalTableRow = /*#__PURE__*/React.createElement(TotalTableRow, {
    key: "totalTableRow",
    staffCostTotals: selectedProject.project_elster_detail.total_for_staff_cost,
    showHalfYearColumn: showHalfYearColumn
  });
  return /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    hover: true,
    className: "elster-employee-table"
  }, /*#__PURE__*/React.createElement("thead", null, groupHeaderRow, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, emptyRows, totalTableRow));
};
export default StaffCosts;